<template>
  <div class="example">
    <b-card>
      <b-card-header>
        <b-card-title>Inventory Value per Product Category</b-card-title>
      </b-card-header>
      <div v-if="validData.length > 0">
        <apexchart 
          type="pie"
          height="350"
          :options="chartOptions"
          :series="series"
        />
      </div>
      <div v-else class="text-center py-5">
        <i class="fas fa-chart-pie text-muted mb-3" style="font-size: 3rem;"></i>
        <h4 class="text-muted">No Inventory Value Data Available</h4>
        <p>There is no inventory value data for the selected date range. Try selecting a different period.</p>
      </div>
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";

export default {
  name: "InventoryValueChart",
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  components: {
    apexchart: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
  },
  computed: {
    validData() {
      if (!this.data || !Array.isArray(this.data)) {
        return [];
      }
      
      // Filter for items with valid amount values
      return this.data.filter(item => 
        item && 
        item.name && 
        item.amount !== undefined && 
        Number(item.amount) > 0
      );
    },
    series() {
      return this.validData.map(item => Number(item.amount));
    },
    chartOptions() {
      return {
        chart: {
          type: 'pie',
          height: 350,
        },
        labels: this.validData.map(item => item.name),
        tooltip: {
          y: {
            formatter: function (val) {
              return val.toFixed(2);
            }
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'center',
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.config.labels[opts.seriesIndex] + ': ' + val.toFixed(1) + '%';
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 300
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      };
    }
  }
};
</script>